import { useState } from 'react';
import { MdCloudUpload } from 'react-icons/md';
import { Button } from '@nbirl/nbi-common-ui-libs';

import { BulkUploadModal } from './bulk-upload-modal.component';

type BulkUploadProps = { folderId: string; path: string };

export const BulkUpload = ({ folderId, path }: BulkUploadProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <>
      <Button
        leftIcon={<MdCloudUpload />}
        variant="ghost"
        onClick={() => setIsModalOpen(true)}
      >
        Upload Documents
      </Button>

      <BulkUploadModal
        path={path}
        folderId={folderId}
        isOpen={isModalOpen}
        onDismiss={() => setIsModalOpen(false)}
      />
    </>
  );
};
